import { call } from 'redux-saga/effects';

import { history } from './history';
import { state, isSagaObject } from './state';
import { store } from './store';
import { ReduxProvider } from './ReduxProvider';


export * from './types';
export * from './utils';

export const redux = {
    $ignore: [
        isSagaObject,
    ],

    history,

    state,
    store,

    API: {
        call,
    },
    renderChain: [
        [ReduxProvider, 50],
    ],
};
